import { render, staticRenderFns } from "./ContainerPlanMantenimiento.vue?vue&type=template&id=70b2c312&"
import script from "./ContainerPlanMantenimiento.vue?vue&type=script&lang=ts&"
export * from "./ContainerPlanMantenimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('70b2c312', component.options)
    } else {
      api.reload('70b2c312', component.options)
    }
    module.hot.accept("./ContainerPlanMantenimiento.vue?vue&type=template&id=70b2c312&", function () {
      api.rerender('70b2c312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/TiposdeInformes/TipoMantenimiento/ContainerPlanMantenimiento.vue"
export default component.exports